'use client';

import * as React from 'react';
// import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface PriceSectionProps {
	price: string;
	isPerHour?: boolean;
	isPOA?: boolean;
	isEnterpise?: boolean;
	serviceId: string;
	compact?: boolean;
}

export const PriceSection: React.FC<PriceSectionProps> = ({
	price,
	isPerHour,
	isPOA,
	// serviceId,
	compact = false,
}) => {
	// const navigate = useNavigate();

	return (
		<div
			className={cn(
				'flex justify-between items-center w-full border-t border-neutral-800 border-opacity-20 rounded-b-3xl',
				compact ? 'gap-2 pt-2 mt-2' : 'gap-8 pt-6 mt-6 max-w-[362px]',
			)}
		>
			<div
				className={cn('self-stretch my-auto', compact ? 'w-auto' : 'w-[173px]')}
			>
				<div
					className={cn(
						'font-bold leading-tight',
						compact ? 'text-[10px]' : 'text-xs',
					)}
				>
					PRICE
				</div>
				<div
					className={cn(
						'mt-1 font-black leading-none',
						compact ? 'text-lg' : 'mt-2 text-3xl',
					)}
				>
					{isPOA ? 'Request Quote' : `R${price}`}
					{isPerHour && (
						<span className={compact ? 'text-xs' : 'text-base'}> p/hr</span>
					)}
				</div>
			</div>
			{/* <button
				onClick={() => navigate(`/services/${serviceId}`)}
				className={cn(
					'self-stretch font-bold text-center bg-[#fbb040] rounded-2xl',
					compact
						? 'p-1.5 text-xs leading-3 w-auto px-3'
						: 'p-2 my-auto text-base leading-4 w-[158px]',
				)}
			>
				{compact ? 'Learn more' : 'Learn more'}
			</button> */}
		</div>
	);
};
